function initPage2(vm, self) {
	vm.checkInvestment = true;

	vm.validatePage2 = function() {
		var flag = false;
		flag = vm.validateAllRequired(flag);
		return flag;
	}

	vm.validatePage2Send = function() {
		var flag = false;
		if ((vm.checkInvestment && vm.proposal.contractType == 'UR2')
				|| vm.proposal.basic.sumAssured == null
				|| vm.proposal.basic.policyTerm == null
				|| (vm.proposal.contractType !== 'VL4'
						&& vm.proposal.frequency !== '00' && vm.proposal.basic.premiumTerm == null)) {
			self.addAlert('Tab thông tin SP chưa nhập đầy đủ thông tin.',
					'danger');
			flag = true;
		}
		if(vm.benefitItems !== undefined && vm.benefitItems.length > 1) {
			if (vm.proposal.benefitItem === undefined
					|| vm.proposal.benefitItem === null
					|| vm.proposal.benefitItem === '') {
				self.addAlert('Quyền lợi bảo hiểm chưa được chọn', 'danger');
				flag = true;
			}
		}
		return flag;
	}
}
